module.exports = (__webpack_require__(0))(42);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/CollectionModel.js from dll-reference girder_lib
// module id = 83
// module chunks = 0